import { Fragment } from 'react'
import { createPortal } from 'react-dom'

interface Props {
	message: string
	type?: string | null
	onClose: () => void
}

export const Message = ({ type, message, onClose }: Props) => {
	return (
		<Fragment>
			{createPortal(
				<div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[999999]">
					<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-mobile w-full p-4">
						<div className="bg-white p-3 text-center rounded-3xl shadow-xl">
							{type === 'error' && (
								<img
									className="inline-block h-12 -mt-6"
									src={require('@/assets/images/message/warning.png')}
								/>
							)}
							{type === 'success' && (
								<img
									className="inline-block h-12 -mt-6"
									src={require('@/assets/images/message/success.png')}
								/>
							)}
							{/* <div className="font-outfit font-semi-bold text-base">
								{title}
							</div> */}
							<div className="font-outfit font-regular text-sm text-center my-4 max-h-80 overflow-y-auto">
								<div>{message}</div>
							</div>
							<button
								className="w-full h-10 bg-blue-600 hover:bg-blue-700 font-medium text-base text-white rounded-full"
								onClick={onClose}
							>
								OK
							</button>
						</div>
					</div>
				</div>,
				document.body
			)}
		</Fragment>
	)
}
